import React from "react";
import "./container.scss";

const Container = ({ children, label, compact = false, tituloContainer = '', margin }) => {
  return (
    <div className={compact ? "container-compact" :"container"} style={{marginTop:  margin}}>
      <div className={compact ? "container__cont-compact" : "container__cont"}>
        {tituloContainer ? <h2 className="container__titulo">{tituloContainer}</h2> : null }
        {label && (
          <div className="container__label">
            <h2 className="titulo__label">{label}</h2>
          </div>
        )}

        <div className="container__componente">{children}</div>
      </div>
    </div>
  );
};

export default Container;
